"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var RichTextViewComponent_1;
const core_1 = require("@angular/core");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
const idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
const idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
const idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
const Observable_1 = require("rxjs/Observable");
const operators_1 = require("rxjs/operators");
const Subject_1 = require("rxjs/Subject");
const multilingual_type_helper_1 = require("../../../shared/multilingual-type-helper");
const rich_text_builder_component_1 = require("../builder/rich-text-builder.component");
const rich_text_state_1 = require("../model/rich-text-state");
const rich_text_component_1 = require("../rich-text.component");
let RichTextViewComponent = RichTextViewComponent_1 = class RichTextViewComponent {
    constructor(communicationService, messageService, currentLanguageProvider) {
        this.communicationService = communicationService;
        this.messageService = messageService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.initialized = false;
        this.isCardTitleLongerThenToolbarSection = false;
        this.destroy$ = new Subject_1.Subject();
    }
    set state(state) {
        this.richTextTemplate = rich_text_state_1.RichTextState.stateFromJSON(state);
    }
    set title(title) {
        this.richTextTitle = multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(title);
    }
    ngOnInit() {
        this.loadLanguageAndMessages();
    }
    ngAfterViewInit() {
        this.initialized = true;
        if (this.txtToolbarSection && this.txtToolbarTitle) {
            let toolbarTitleMarginRight = 16;
            this.isCardTitleLongerThenToolbarSection = this.txtToolbarSection.nativeElement.offsetWidth === this.txtToolbarTitle.nativeElement.offsetWidth + toolbarTitleMarginRight;
        }
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    getExportDto(type) {
        const exportType = idm_report_export_service_client_js_1.ExportType[idm_dynamic_controls_metadata_1.ExportType[type]];
        const params = new Map()
            .set('exportType', idm_report_export_service_client_js_1.ExportType[exportType]);
        return {
            url: null,
            serviceKey: null,
            serviceContext: null,
            method: "",
            cardTitle: this.richTextTitle.getValue(this.currentLanguageId) || this.untitledMessage,
            headers: new Map(),
            contentType: "text/html",
            body: this.richTextTemplate.htmlTemplate.getValue(this.currentLanguageId),
            params: params,
        };
    }
    sendWidgetExportData() {
        const exportData = {
            id: this.id,
            title: this.richTextTitle.getValue(this.currentLanguageId) || this.untitledMessage,
            isOrientable: false,
            getExportDto: this.getExportDto.bind(this),
            excludeExportTypes: [idm_dynamic_controls_metadata_1.ExportType.EXCEL]
        };
        const message = new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.WIDGET_EXPORT_DATA, exportData);
        this.communicationService.parentSubject.next(message);
    }
    loadLanguageAndMessages() {
        const currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        const untitledMessage$ = this.messageService.getMessage(RichTextViewComponent_1.UNTITLED_MESSAGE_KEY);
        Observable_1.Observable.zip(currentLanguage$, untitledMessage$)
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe(data => {
            this.currentLanguageId = data[0].getId();
            this.untitledMessage = data[1];
            this.sendWidgetExportData();
        });
    }
};
RichTextViewComponent.UNTITLED_MESSAGE_KEY = 'reporting.controls.rich-text.untitled';
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RichTextViewComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RichTextViewComponent.prototype, "componentId", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], RichTextViewComponent.prototype, "state", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], RichTextViewComponent.prototype, "title", null);
__decorate([
    core_1.ViewChild('txtToolbarSection'),
    __metadata("design:type", core_1.ElementRef)
], RichTextViewComponent.prototype, "txtToolbarSection", void 0);
__decorate([
    core_1.ViewChild('txtToolbarTitle'),
    __metadata("design:type", core_1.ElementRef)
], RichTextViewComponent.prototype, "txtToolbarTitle", void 0);
RichTextViewComponent = RichTextViewComponent_1 = __decorate([
    core_1.Component({
        
        selector: 'sis-rich-text-view',
        template: require('./rich-text-view.component.html'),
        styles: [require('./rich-text-view.component.css')]
    }),
    idm_dynamic_controls_metadata_1.ControlMetadata({
        cellCount: 12,
        groups: [
            {
                identity: "ReportingControls",
                name: "Reporting Controls",
                nameMessageKey: "reporting.controls.group.name",
            },
        ],
        settings: {
            main: rich_text_builder_component_1.RichTextBuilderComponent,
            central: rich_text_component_1.RichTextComponent
        },
        template: `<sis-rich-text-view 
                    [id]="controlId" 
                    [componentId]='%{componentId}' 
                    [state]='%{state}' 
                    [title]='%{title}'></sis-rich-text-view>`,
        iconInfo: "multi_text",
        name: "Rich Text",
        nameKey: "reporting.controls.rich-text.widget.label",
        height: 650
    }),
    __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService,
        idm_message_language_service_client_js_1.MessageService,
        idm_session_data_provider_api_js_1.CurrentLanguageProvider])
], RichTextViewComponent);
exports.RichTextViewComponent = RichTextViewComponent;
//# sourceMappingURL=rich-text-view.component.js.map